import React, { useState } from "react";

const ItemsReadyModal = ({
  itemsReadyPopup,
  setItemsReadyPopup,
  orderId,
  onSuccess,
}) => {
  const [image, setImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Open File Picker (Gallery)
  const openGallery = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  // Remove selected image
  const removeImage = () => {
    setImage(null);
  };

  // Submit image + status
  const submitPackedItems = async () => {
    if (!image) {
      alert("Please upload a photo first.");
      return;
    }

    try {
      setIsSubmitting(true);

      // Retrieve token (localStorage used in web)
      const vendorDataString = localStorage.getItem("vendorData");
      const vendorData = vendorDataString ? JSON.parse(vendorDataString) : null;
      const token = vendorData?.token;

      if (!token) {
        alert("Authentication failed. Please login again.");
        setIsSubmitting(false);
        return;
      }

      const formData = new FormData();
      formData.append("id", orderId);
      formData.append("status", "Ready For Delivery");
      formData.append("images", image);

      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/change-status-to-items-ready-in-purchase-order`,
        {
          method: "PUT",
          headers: {
            "x-token": token,
          },
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        alert("Status updated successfully.");
        if (onSuccess) onSuccess();
        setItemsReadyPopup(false);
        setImage(null);
      } else {
        alert(result.message || "Failed to update status.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!itemsReadyPopup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white w-full max-w-md rounded-xl shadow-lg overflow-hidden">

        {/* Header */}
        <div className="flex justify-between items-center border-b px-4 py-3">
          <h2 className="text-lg font-semibold">Upload Packed Items</h2>
          <button
            disabled={isSubmitting}
            onClick={() => setItemsReadyPopup(false)}
            className="text-gray-500 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-sm text-gray-700 mb-3">
            1. Upload a clear photo of the packed items ready for pickup.
          </p>

          {/* Image Preview */}
          {image ? (
            <div className="mb-4 relative">
              <img
                src={URL.createObjectURL(image)}
                alt="preview"
                className="w-full h-48 object-cover rounded-lg"
              />
              <button
                onClick={removeImage}
                className="absolute top-2 right-2 bg-black/60 text-white rounded-full w-7 h-7 flex items-center justify-center"
              >
                ✕
              </button>
            </div>
          ) : (
            <p className="text-gray-500 text-sm mb-4">No image selected</p>
          )}

          {/* Upload Button */}
          <div className="mb-4">
            <label className="cursor-pointer bg-gray-100 border border-gray-300 px-4 py-2 rounded-lg inline-block">
              📁 Choose Image
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={openGallery}
                disabled={isSubmitting}
              />
            </label>
          </div>

          {/* Step 2 */}
          <p className="text-sm text-gray-700 mb-4">
            2. <span className="font-semibold">Submit</span> to notify the delivery partner.
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              disabled={isSubmitting}
              onClick={() => {
                setItemsReadyPopup(false);
                setImage(null);
              }}
              className="flex-1 border border-gray-300 py-3 rounded-lg text-gray-700 font-medium"
            >
              Cancel
            </button>

            <button
              disabled={!image || isSubmitting}
              onClick={submitPackedItems}
              className={`flex-1 py-3 rounded-lg text-white font-semibold ${
                !image || isSubmitting ? "bg-gray-400" : "bg-red-500"
              }`}
            >
              {isSubmitting ? "Uploading..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemsReadyModal;
